<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Customer Insights</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="divider"></div>
    <div *ngIf="allFacilities?.length > 1" class="filter">
      <button [matMenuTriggerFor]="facilitiesMenu" mat-button class="icon-btn">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
      <mat-menu
        class="mat-menu-elaphant vertical-menu facilities-menu"
        #facilitiesMenu="matMenu"
      >
        <mat-checkbox
          *ngFor="let facility of allFacilities"
          class="checkbox"
          color="lightGreen"
          [(ngModel)]="facility.selected"
          (change)="onFacilityChange(facility)"
        >
          {{ facility.name }}</mat-checkbox
        >
      </mat-menu>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>

<div class="customer-insights">
  <div class="columns">
    <div class="column">
      <div class="container on-prop-visits-freq-container">
        <div class="container-header no-bottom-border">
          <div class="text">On Property Visit Frequency</div>
        </div>
        <div class="container-content">
          <div
            echarts
            [options]="onPropVisitFreqOptions"
            class="bar-chart"
          ></div>
        </div>
      </div>

      <div class="container competitor-visits-freq-container">
        <div class="container-header no-bottom-border">
          <div class="text">Competitor Visit Frequency</div>
        </div>
        <div class="container-content">
          <div
            echarts
            [options]="competitorVisitFreqOptions"
            class="bar-chart"
          ></div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="container days-since-last-visit-container">
        <div class="container-header no-bottom-border">
          <div class="text">Days since last visit</div>
        </div>
        <div class="container-content">
          <div
            echarts
            [options]="daysSinceLastVisitOptions"
            class="bar-chart"
          ></div>
        </div>
      </div>

      <div class="container time-on-station-container">
        <div class="container-header no-bottom-border">
          <div class="text">Time on station (minutes)</div>
        </div>
        <div class="container-content">
          <div echarts [options]="timeOnStationOptions" class="bar-chart"></div>
        </div>
      </div>

      <div class="container competitor-visits-container">
        <div class="container-header no-bottom-border">
          <div class="text">Competitor visits</div>
        </div>
        <div class="container-content">
          <div
            echarts
            [options]="competitorVisitsOptions"
            class="bar-chart"
          ></div>
        </div>
      </div>
    </div>

    <div class="column">
      <div class="container gender-container">
        <div class="container-header no-bottom-border">
          <div class="text">Gender</div>
        </div>
        <div class="container-content">
          <div echarts [options]="genderOptions" class="pie-chart"></div>
        </div>
      </div>
    </div>
  </div>
</div>
